import React from "react";
import GetAppRoundedIcon from "@material-ui/icons/GetAppRounded";
import IconButton from "@material-ui/core/IconButton";
// import styles from "./generatepdf.module.css";
import alderLogo from "../../../../assets/img/alder-logo.png";
import styles from "../DownloadInventory.module.css";
import { Tooltip } from "@material-ui/core";
import { renderToString } from "react-dom/server";
import jsPDF from "jspdf";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
// import Table from "../../../views/Table/Table.js";
const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },
}));
const DownloadProductInventory = (props) => {
  const classes = useStyles();
  console.log("Pr Inv Generate PDF Page");
  console.log(props);
  const InvoiceHtml = (props) => {
    console.log("Pr Inv HTML");
    console.log(props);
    return (
      <div className={styles.container}>
        {console.log("hiiii")}
        {console.log(props.details)}
        <div className={styles.content}>
          <div className={styles.header}>
            <img src={alderLogo} alt="alder logo" />
            <div className={styles.contentright}>
              <h3>Alder Furniture Pvt Ltd</h3>
              <h3>
                27 Furniture Block, Kirti Nagar, New Delhi – 110015, INDIA
              </h3>
              <h3>
                website: www.alder.in, Email: info@alder.in | sales@alder.in
              </h3>
              <h3>Phone: +91-011-42903322</h3>
            </div>
          </div>
          <div className={styles.alignStart}>
            <p>Warehouse Product Inventory</p>
          </div>

          <div className={styles.alignStart}>
            <p>Warehosue Detail</p>
            <table className={styles.table} border="1">
              <thead className={styles.tableHeader}>
                <tr>
                  <th>"Name</th>
                  <th>Bar Code</th>
                  <th>Address</th>
                  <th>Location</th>
                  <th>Contact Number</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{props.name ? props.name.name : "Nan"}</td>
                  <td>{props.name ? props.name.warehouse_barcode : "Nan"}</td>
                  <td>{props.name ? props.name.address : "Nan"}</td>
                  <td>{props.name ? props.name.warehouseLocation : "Nan"}</td>
                  <td>{props.name ? props.name.contactNum : "Nan"}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className={styles.alignStart}>
            <p>Product Detail</p>
            <table className={styles.table} border="1">
              <thead className={styles.tableHeader}>
                <tr>
                  <th>Product Name</th>
                  <th>Product Code</th>
                  <th>Category</th>
                  <th>Warehouse Stock</th>
                  <th>Booked Stock</th>
                  <th>Balance Stock</th>
                  <th>Product cost</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{props.product.objectId.productName}</td>
                  <td>{props.product.objectId.product_barcode}</td>
                  <td>
                    {props.product.objectId.categories
                      ? props.product.objectId.categories.categoryName
                      : "Nan"}
                  </td>
                  <td>{props.product.warehouseStock}</td>
                  <td>{props.product.bookedStock}</td>
                  <td>{props.product.balanceStock}</td>
                  <td>{props.product.objectId.productCost}</td>
                  <td>{props.product.objectId.status}</td>
                  
                </tr>
              </tbody>
            </table>
          </div>
          <div className={styles.alignStart}>
            <p>Parts Details</p>
            <table className={styles.table} border="1">
              <thead className={styles.tableHeader}>
                <tr>
                  <th>Part Name</th>
                  <th>Part Code</th>
                  <th>Length</th>
                  <th>Width</th>
                  <th>Weight</th>
                  <th>Height</th>
                  <th>Status</th>
                  <th>quantity</th>
                </tr>
              </thead>

              <tbody>
                {props.details.map((items, index) => {
                  return (
                    <tr>
                      {items.map((subItems, sIndex) => {
                        if (sIndex < 8) return <td>{subItems}</td>;
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  };
  const print = () => {
    const htmlString = renderToString(
      <InvoiceHtml
        details={props.details}
        name={props.name}
        product={props.product}
        quantity={props.quantity}
      />
    );

    const pdf = new jsPDF({
      orientation: "p",
      unit: "pt",
      format: "a3",
    });
    pdf.setTextColor(0, 0, 0);
    pdf.html(htmlString, {
      callback: function (pdf) {
        let filename = `part details.pdf`;
        pdf.save(filename);
      },
    });
  };
  return (
    <React.Fragment>
      <Tooltip title="Download Part details">
        <Button
          onClick={print}
          variant="contained"
          color="default"
          className={classes.button}
          startIcon={<GetAppRoundedIcon />}
        >
          Download Part details
        </Button>
      </Tooltip>
    </React.Fragment>
  );
};
export default DownloadProductInventory;
